import { render, staticRenderFns } from "./MemoList.vue?vue&type=template&id=2a45f89e&scoped=true"
import script from "./MemoList.vue?vue&type=script&lang=js"
export * from "./MemoList.vue?vue&type=script&lang=js"
import style0 from "./MemoList.vue?vue&type=style&index=0&id=2a45f89e&prod&lang=css"
import style1 from "./MemoList.vue?vue&type=style&index=1&id=2a45f89e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a45f89e",
  null
  
)

export default component.exports